import React, { useState } from 'react';
import { Badge, Menu, MenuItem } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import SwapVert from '@mui/icons-material/SwapVert';
import { SortOrder, useListContext } from 'framework/list';
import { Tooltip } from 'framework/ui/mui-builder';

const RiskSortableButton = () => {
  const { sort, sortBy } = useListContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => setAnchorEl(null);

  const onMenuItemClick = (source: string, order: SortOrder | '') => {
    sortBy?.(source, order as SortOrder);
    handleClose();
  };

  return (
    <>
      <Tooltip title="Sorting">
        <IconButton
          id="risk-sort-button"
          aria-controls={open ? 'risk-sort-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={e => setAnchorEl(e.currentTarget)}
          color="default"
        >
          <Badge variant="dot" color="primary" invisible={!sort?.field}>
            <SwapVert />
          </Badge>
        </IconButton>
      </Tooltip>
      <Menu
        id="risk-sort-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{ list: { 'aria-labelledby': 'risk-sort-button' } }}
      >
        <MenuItem
          disabled={sort?.field === '_effectiveUpdatedAt' && sort?.order === 'DESC'}
          onClick={() => onMenuItemClick('_effectiveUpdatedAt', 'DESC')}
        >
          Newest updates first
        </MenuItem>
        <MenuItem
          disabled={sort?.field === '_effectiveUpdatedAt' && sort?.order === 'ASC'}
          onClick={() => onMenuItemClick('_effectiveUpdatedAt', 'ASC')}
        >
          Oldest updates first
        </MenuItem>
        {sort?.field ? <MenuItem onClick={() => onMenuItemClick('', '')}>Reset</MenuItem> : null}
      </Menu>
    </>
  );
};

export default RiskSortableButton;
